import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

import TableCrudEnhanced from '../../components/TableCrudEnhanced';

const KPIIndex = () => {
    const navigate = useNavigate();

    // Configuração de filtros específica para SubSectionKPI
    const filterConfig = useMemo(() => [        
        {
            type: "text",
            name: "description",
            label: "Description",
            placeholder: "Description..."
        },
        {
            type: "text",
            name: "subSectionDescription",
            label: "Sub Section Description",
            placeholder: "Sub Section Description..."
        }
    ], []);

    // Colunas da tabela
    const columns = useMemo(() => [
        {
            title: "Form",
            dataIndex: "subSection.description",
            key: "subSection.description",
            sortable: true 
        },
        { 
            title: 'Description', 
            dataIndex: 'description', 
            key: 'description', 
            sortable: true 
        },
        { 
            title: 'Order', 
            dataIndex: 'order', 
            key: 'order', 
            sortable: true,
            width: 100
        },        
        { 
            title: 'Active', 
            dataIndex: 'isActive', 
            key: 'isActive', 
            width: 80,
            render: (value, record, index, handleToggleActive) => (
                <span 
                    className={`badge ${value ? 'bg-success' : 'bg-secondary'}`}
                    style={{ cursor: 'pointer' }}
                    onClick={() => handleToggleActive && handleToggleActive(record)}
                    title={`Click to ${value ? 'deactivate' : 'activate'}`}
                >
                    {value ? 'Active' : 'Inactive'}
                </span>
            )
        },
        { 
            title: 'Deleted', 
            dataIndex: 'isDeleted', 
            key: 'isDeleted', 
            width: 100,
            render: (value, record, index, handleToggleActive, handleToggleDeleted) => (
                <span 
                    className={`badge ${!value ? 'bg-success' : 'bg-secondary'}`}
                    style={{ cursor: 'pointer' }}
                    onClick={() => handleToggleDeleted && handleToggleDeleted(record)}
                    title={`Click to ${!value ? 'delete' : 'restore'}`}
                >
                    {!value ? 'Not Deleted' : 'Deleted'}
                </span>
            )
        }
    ], []);

    // Actions
    const actions = useMemo(() => [
        {
            label: 'Edit',
            onClick: (record) => navigate(`/kpi/edit/${record.kpiid}`),
            type: 'primary'
        }
    ], [navigate]);

    return (
        <TableCrudEnhanced
            title="KPI"
            apiEndpoint="/kpi/getAllPaginated"
            toggleActiveEndpoint="/kpi/toggleActive"
            toggleDeletedEndpoint="/kpi/toggleDeleted"
            newRoute="/kpi/new"
            columns={columns}
            filterConfig={filterConfig}
            actions={actions}
            rowKey="kpiid"
            initialPageSize={10}
            enableFilters={true}
            showAddButton={true}
        />
    );
};

export default KPIIndex;

